<template>
  <div v-loading.fullscreen.lock="this.$global.isLoadingSystem"  element-loading-spinner="fas fa-spinner fa-spin">
    <TopBar />
    <router-view :style="{top:(this.$global.charges_enabled === false || this.$global.payouts_enabled === false) && (this.$global.account_requirements !== '') && (isAgency) && (this.$global.isLoadRouterView) ? 50 : 0}"></router-view>
  </div>
</template>

<script>
import Vue from 'vue'
import vueCountryRegionSelect from 'vue-country-region-select'
import TopBar from './components/TopBar.vue';
import axios from 'axios';
Vue.use(vueCountryRegionSelect) 

export default {
  data() {
    return {
      isAgency: false,

      pollingInterval: null,
      exportId: null,
    }
  },
  methods: {
    handleStorageChange(event) {
      // Trigger logout check on any localStorage change
      // localStorage.removeItem('companyGroupSelected');
      // localStorage.removeItem('subdomainAgency');
      // localStorage.removeItem('rootcomp');
      // this.$global.selectsGroupCompany.companyGroupList = null;
      // this.$store.dispatch('destroyToken')
      //   .then(response => {
      //     //this.$router.push({ name: 'Login' })
      //     window.document.location = '/login';
      //   })
    },
    initializeLayout() {
      if (!this.$rtl.isRTL) {
        // Just make sure rtl css is off when we are not on rtl
        this.$rtl.disableRTL();
      }
    },
    startPolling(exportId) {

      console.log('Masuk startPolling');
      
      if (this.pollingInterval) return;

      this.exportId = exportId;

      this.pollingInterval = setInterval(() => {
        // ⛔ Stop polling kalau localStorage udah gak ada (manual dihapus user atau error sebelumnya)
        const currentExportId = localStorage.getItem('clean_id_export_id');
        // const storedData = this.$store.getters.userData;
        // const currentExportId = storedData.clean_id_export_id;
        if (!currentExportId) {
          clearInterval(this.pollingInterval);
          this.pollingInterval = null;
          return;
        }

        axios.get(`/leadspeek/clean-id/export-status/${this.exportId}`)
          .then(res => {
            if (res.data.status === 'done') {
              clearInterval(this.pollingInterval);
              this.pollingInterval = null;

              localStorage.removeItem('clean_id_export_id');
              // let userData = JSON.parse(localStorage.getItem('userData'));
              // if (userData && typeof userData === 'object' && userData.clean_id_export_id) {
              //   delete userData.clean_id_export_id;
              //   localStorage.setItem('userData', JSON.stringify(userData));
              // }

              const link = document.createElement('a');
              link.href = res.data.download_url;
              link.download = '';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
 

              axios.get(`/leadspeek/clean-id/del-files/${exportId}`)
              .then(res => {
                  this.$notify({
                      type: 'success',
                      message: 'Exporting file success.',
                      icon: 'fas fa-check'
                  });  
              })
              .catch(err => {
                  // console.error('Error checking export status:', err);
                  clearInterval(interval);
                  this.loadingExportId = null;

                  this.$notify({
                      type: 'danger',
                      message: 'File Not Found.. Please Try Again.',
                      icon: 'fas fa-check'
                  });  
              });
              
            }
          })
          .catch(err => {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
            localStorage.removeItem('clean_id_export_id');
            // let userData = JSON.parse(localStorage.getItem('userData'));
            //   if (userData && typeof userData === 'object' && userData.clean_id_export_id) {
            //     delete userData.clean_id_export_id;
            //     localStorage.setItem('userData', JSON.stringify(userData));
            //   }
            this.$notify({
              type: 'danger',
              message: 'Process Download Clean ID error/stopped. Try Again.',
              icon: 'fas fa-exclamation-circle'
            });
          });
      }, 2000);
    }
  },
  mounted() {
    const storedData = this.$store.getters.userData;
    
    if(storedData){
      document.documentElement.style.setProperty('--bg-bar-color', storedData.sidebar_bgcolor);
      document.documentElement.style.setProperty('--text-bar-color', storedData.text_color);
      this.isAgency = storedData.user_type === 'userdownline';
    }

    this.initializeLayout();
    // Add event listener for storage events
    //window.addEventListener('storage', this.handleStorageChange);

    // Cek apakah ada export ID di localStorage setelah reload
    const exportId = localStorage.getItem('clean_id_export_id');
    if (exportId) {
      this.startPolling(storedData.clean_id_export_id);
    }
    // if (storedData.clean_id_export_id) {
    //   this.startPolling(storedData.clean_id_export_id);
    // }
    // let userData = JSON.parse(localStorage.getItem('userData'));
    // if (userData && userData.clean_id_export_id) {
    //   this.startPolling(userData.clean_id_export_id);
    // }
    

  },
  beforeDestroy() {
    // Remove event listener when component is destroyed
    //window.removeEventListener('storage', this.handleStorageChange);
  },
  created() {
    this.$root.$on('startPolling', (exportId) => {
      // localStorage.setItem('clean_id_export_id', exportId);

      // let userData = JSON.parse(localStorage.getItem('userData'));
      // if (userData && typeof userData === 'object') {
      //   userData.clean_id_export_id = exportId;
      //   localStorage.setItem('userData', JSON.stringify(userData));
      // }
      console.log('Start polling received in App.vue:', exportId);
      this.startPolling(exportId);
    });
  },
  // watch: {
  //   '$store.state.auth.userData.clean_id_export_id'(newVal) {
  //     if (newVal) {
  //       console.log('Watcher triggered for clean_id_export_id:', newVal);
  //       this.startPolling(newVal);
  //     }
  //   }
  // },
  components: {
    TopBar
  }
};
</script>
<style >

:root {
  --background-color-primary: #f5f5f5;
  --background-color-secondary: #ffffff;
  --card-border-color: #ffffff;
  --primary-color: #374151;
  --accent-color: #212529;
  --primary-input-text-color: #212529;
  --dark: #212529;
  --text-primary-color: #101111;
  --element-size: 64px;
  --input-border-color: #101111;
  --btn-primary-color: #101111;
  --btn-primary-hover-color: #263148;  
  --em-primary: #374151;
  --bg-bar-color: #f5f5f5;
  --text-bar-color: #101111;
  --text-underline-color: #0833f7;
  --btn-black-color: #131920;
  --text-btn-black: #ddd;
  --link-color: #4286f4;  
  --base-text: #000000;
  --muted: #f4f4f5;
  --table-hover-color:#F5F7FA;
  --secondary-border-card: #EBEEF5;
  --tab-text-color: #6b7280;
  --tab-hover-color: #374151;
  --overlay-background: rgba(255, 255, 255, 0.5);
}


/* :root.dark-theme {
  
  --background-color-primary: #2D3250;
  --background-color-secondary: #424769;
  --primary-color: #F6B17A;
  --accent-color: #c3c3c3;
  --primary-input-text-color: #e9e9e9;
  --gray-900: #e9e9e9;
  --dark: #d4d5d6;
  --text-primary-color: #ddd;
  --input-border-color: #ffffff;
  --bs-primary: #7267ef;
  --bs-secondary: #6c757d;
} */
:root.dark-theme {
  /* --background-color-primary: #1e1e1e; */
  --background-color-primary: #131920;
  --background-color-secondary: #1b232d;
  --card-border-color: #263240;
  --primary-color: #ffffff;
  --accent-color: #c3c3c3;
  --primary-input-text-color: #e9e9e9;
  --gray-900: #e9e9e9;
  --dark: #d4d5d6;
  --text-primary-color: #ddd;
  --input-border-color: #ffffff;
  --em-primary: #686868;
  --btn-primary-color: #686868;
  --btn-primary-hover-color: #5b5b65;
  --bs-secondary: #6c757d;
  --link-color: #4286f4;  
  --bg-bar-color: #131920;
  --text-bar-color: #ddd;
  --text-underline-color: #0833f7;
  --btn-black-color: #131920;
  --text-btn-black: #ddd;
  --base-text: #ffffff;
  --muted: #263240;
  --table-hover-color:#263240;
  --secondary-border-card: gray;
  --tab-text-color: #9ca3af;
  --tab-hover-color: #d1d5db;
  --overlay-background: rgba(27, 35, 45, 0.7);
}

.bg-bar-color {
  background-color: var(--bg-bar-color) !important;
}

.text-bar-color {
    color: var(--text-bar-color) !important;
}

.text-underline-color {
  color: var(--text-underline-color) !important;
}

.btn-black-color {
  background-color: var(--btn-black-color) !important;
  color: var(--text-btn-black) !important;
}
.cursor-pointer{
  cursor: pointer;
}

.el-loading-spinner i {
  font-size: 40px;
  color: var(--btn-primary-color) !important;
}
.selerator-campaign-create{

height: 3px;
background: #d8d8d8;
border-radius: 3px;
margin: 25px 15px;
width: 100%;
}
</style>